import RegisterThankYouPopup from './RegisterThankYouPopup';

export default RegisterThankYouPopup;
